import styled from 'styled-components';
import photo1 from 'assets/images/8.jpg';
import photo2 from 'assets/images/9.jpg';

export const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 64px;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  column-gap: 16px;
  margin-bottom: 16px;

  @media screen and (max-width: 500px) {
    flex-direction: column;
    row-gap: 16px;
    img {
      max-width: 100%;
    }
  }
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  width: 100%;
  max-width: calc(50% - 8px);
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  width: 100%;
  max-width: calc(50% - 8px);
`;

export const Caption = styled.div`
  max-width: 650px;
  font-size: 14px;
  text-align: center;
  margin: 0 auto;

  &.mobile {
    display: none;
  }

  @media screen and (max-width: 500px) {
    padding: 0 40px;
    &.desktop {
      display: none;
    }
    &.mobile {
      display: block;
    }
  }
`;
